import { render, staticRenderFns } from "./ShadowProjection.vue?vue&type=template&id=57671faf"
import script from "./ShadowProjection.vue?vue&type=script&lang=js"
export * from "./ShadowProjection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57671faf')) {
      api.createRecord('57671faf', component.options)
    } else {
      api.reload('57671faf', component.options)
    }
    module.hot.accept("./ShadowProjection.vue?vue&type=template&id=57671faf", function () {
      api.rerender('57671faf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/ShadowProjection.vue"
export default component.exports